import { render, staticRenderFns } from "./EmployeeInfoItem.vue?vue&type=template&id=305315fa&scoped=true"
import script from "./EmployeeInfoItem.vue?vue&type=script&lang=js"
export * from "./EmployeeInfoItem.vue?vue&type=script&lang=js"
import style0 from "./EmployeeInfoItem.vue?vue&type=style&index=0&id=305315fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305315fa",
  null
  
)

export default component.exports